import 'antd/dist/antd.css'
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Style from './not-found-page.module.scss';
 
const NotFoundPage: React.FC<any> = (prop) => {
    let location = useLocation();
    return (
        <>
            <div className={Style.Centro}>
                <div className={Style.Titulo}>
                    Página não encontrada
                </div>
                <br />
                <strong>A página {location.pathname} não existe</strong>
            </div>
        </>
    )
}

export default NotFoundPage;
